const $ = require('../sukoa-jquery.cjs');
const List = require('./List').default;
const Element = require('./Element').default;
const Filter = require('./Filter').default;

export default {
    init: function () {
        let $coursesList = $(".list-component");
        if ($coursesList.size() > 0) {
            let cls = [];
            let self = this;
            $coursesList.each(function () {
                let list = new List($(this));
                list.elementsState = self.element(list);
                list.filtersState = self.filter(list);
                 list.activate();
                cls.push(list);
            });

            const selectFilters = [
                { selectId: "objectfilter", styledSelectId: "styled-objectfilter" },
                { selectId: "perffilter", styledSelectId: "styled-perffilter" }
            ]

            selectFilters.forEach(({ selectId, styledSelectId }) => {
                const styledSelect = document.getElementById(styledSelectId);

                if (styledSelect) {
                    const select = document.getElementById(selectId);
                    const items = styledSelect.querySelectorAll("ul.filteroptions li");
                    const display = styledSelect.querySelector("p.selected");

                    this.display(items, select, display);
                }
            });
        }
    },

    element: function (list) {
        let elementsState = [];
        list.$elements.each(function () {
            elementsState.push(new Element(list, $(this)).activate());
        });

        return elementsState;
    },

    filter: function (list) {
        let filterState = [];
        list.$filters.each(function () {
            filterState.push(new Filter(list, $(this)).activate());
        });

        return filterState;
    },

    display: function (listItems, select, display) {
        // Makes sure that when clicking "Filter zurücksetzen" from the dropdown, the UI shows "Objektart" again as the selected label
        listItems.forEach(item => {
            item.addEventListener("click", () => {
                const val = item.dataset.value
                select.value = val

                if (val === "0") {
                    display.textContent = display.dataset.default
                } else {
                    display.textContent = item.textContent
                }

                display.setAttribute("data-value", val)
                select.dispatchEvent(new Event("change"))
            });
        });
    }

};
